/**
 * @module events/types/focus
 */

/**
 * @type {string}
 */
export default 'focus'
